import React from 'react'

import {default as t} from '../utils/Translate'

const Placeholder = ({original, placeholder}) => (
    <div className="item placeholder">
        {React.cloneElement(
            placeholder || original,
            {
                ...(placeholder || original).props,
                ...(placeholder || original).type.placeholder,
                campaign: {
                    ...(placeholder || original).props.campaign,
                    ...(placeholder || original).type.placeholder.campaign,
                }
            }
        )}
    </div>
)

const Carousel = ({children, placeholder, headline, lang, more = 'All offers'}) => (
    <React.Fragment>
        <div className="carousel mam3-type border">
            <div className="header">
                <div className="title">{t(headline, lang)}</div>

                <div className="more">{t(more, lang)}</div>
            </div>

            <div className="wrapper">
                <div className="controls">
                    <div className={(placeholder || children).props.className}>
                        <img src={(placeholder || children).props.image} className="dummy img-fluid" alt="dummy" />
                    </div>
                    <button className="prev"></button>
                    <button className="next"></button>
                </div>

                <div className="track">
                    <Placeholder original={children} placeholder={placeholder} />
                    <div className="item">
                        {children}
                    </div>
                    <Placeholder original={children} placeholder={placeholder} />
                </div>
            </div>
        </div>
    </React.Fragment>
)

export default Carousel



// WEBPACK FOOTER //
// ./src/components/subcomponents/Carousel.js